import React, { useMemo } from 'react';
import { useImmer } from 'use-immer';
import { UndefinedAsset, Model } from '../Asset';
import { OfficialAssetContentBanner } from './OfficialAssetnContentBanner';
import { AssetItem } from '@/type';
import { SelectedCategoryType } from '../..';

export function OfficialAssetContent(props: {
  workingFolder: SelectedCategoryType | null; // 所属的目录Id
  data: AssetItem[] | undefined;
  onModelClick: (item: AssetItem) => void;
}) {
  const { workingFolder, data, onModelClick } = props;
  const [contentQuery, setContentQuery] = useImmer<string>('');

  const filteredData = useMemo(() => {
    return data?.filter((a) => a.name.includes(contentQuery));
  }, [contentQuery, data]);

  const getAssetComp = (item: AssetItem) => {
    switch (item.type) {
      case 'model': {
        return (
          <Model
            key={item.id}
            hideDetail
            data={item as AssetItem<'model'>}
            onSelected={() => {
              onModelClick(item);
            }}
          />
        );
      }
      case 'material':
      case 'image':
      default: {
        return <UndefinedAsset key={item.id} data={item} />;
      }
    }
  };

  return (
    <>
      <OfficialAssetContentBanner workingFolder={workingFolder} setContentQuery={setContentQuery} />
      <div className='px-6 pt-4 grid grid-cols-[repeat(auto-fill,minmax(102px,1fr))] grid-rows-[repeat(auto-fill,1fr)] gap-x-3 gap-y-4 overflow-y-auto no-scroll-container'>
        {filteredData?.map((item) => (
          <div key={item.id} className='w-full flex items-center justify-center'>
            {getAssetComp(item)}
          </div>
        ))}
      </div>
    </>
  );
}
